<template>
  <div class="testimonial-card" data-reveal>
    <span class="quote-mark">&ldquo;</span>
    <p class="body">{{ body }}</p>
    <div class="author">
      <div class="avatar">{{ initials }}</div>
      <p class="name">{{ user }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue"

const props = defineProps({
  body: {
    type: String,
    required: true
  },
  user: {
    type: String,
    required: true
  }
})

const initials = computed(() =>
  props.user
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase()
)
</script>

<style scoped>
.testimonial-card {
  position: relative;
  background: var(--surface);
  padding: 2.5rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  text-align: left;
  transition: transform var(--transition), box-shadow var(--transition);
}

.testimonial-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-md);
}

.quote-mark {
  font-family: var(--font-heading);
  font-size: 3.5rem;
  line-height: 1;
  color: var(--accent-light);
  font-weight: 800;
  display: block;
}

.body {
  color: var(--body-text);
  margin-top: 0.25rem;
  line-height: 1.75;
  font-size: 0.98rem;
}

.author {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-top: 1.75rem;
}

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: var(--primary-tint);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.name {
  font-weight: 700;
  color: var(--ink);
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .testimonial-card {
    padding: 2rem;
  }
}
</style>
